// // // import React from 'react'

// // // const SuperAdminManageTeam = () => {
// // //   return (
// // //     <div>
      
// // //     </div>
// // //   )
// // // }

// // // export default SuperAdminManageTeam





// // import React, { useState, useEffect } from 'react';
// // import styled from 'styled-components';
// // import { useNavigate } from 'react-router-dom';
// // import NavBarSuper from './NavBarSuper';
// // import Footer from './Footer';
// // import api from '../api'; 

// // /* ================= STYLED COMPONENTS ================= */
// // const AppContainer = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   min-height: 100vh;
// //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // `;

// // const PageWrapper = styled.div`
// //   flex: 1 0 auto;
// //   width: min(1200px, calc(100% - 32px));
// //   margin: 90px auto 30px;
// // `;

// // const BackButton = styled.button`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 8px;
// //   background: none;
// //   border: none;
// //   color: #1d4ed8;
// //   font-weight: 800;
// //   font-size: 1.05rem;
// //   cursor: pointer;
// //   margin-bottom: 20px;
// //   padding: 0;
// //   transition: transform 0.2s ease, color 0.2s ease;

// //   &:hover {
// //     color: #1e3a8a;
// //     transform: translateX(-4px);
// //   }
// // `;

// // const HeroCard = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
// //   color: #fff;
// //   border-radius: 24px;
// //   padding: 28px;
// //   margin-bottom: 22px;
// //   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
// // `;

// // const HeroTitle = styled.h1`
// //   margin: 0 0 8px;
// //   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
// //   font-weight: 800;
// // `;

// // const HeroText = styled.p`
// //   margin: 0;
// //   color: rgba(255, 255, 255, 0.86);
// //   font-size: 0.98rem;
// // `;

// // const Grid = styled.div`
// //   display: grid;
// //   grid-template-columns: 1fr 1fr;
// //   gap: 24px;

// //   @media (max-width: 900px) {
// //     grid-template-columns: 1fr;
// //   }
// // `;

// // const ColumnCard = styled.div`
// //   background: rgba(255, 255, 255, 0.96);
// //   border-radius: 22px;
// //   padding: 24px;
// //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// //   border: 1px solid rgba(148, 163, 184, 0.16);
// //   min-height: 500px;
// //   display: flex;
// //   flex-direction: column;
// // `;

// // const Title = styled.h2`
// //   color: #0f172a;
// //   font-size: 1.3rem;
// //   font-weight: 800;
// //   margin: 0 0 20px 0;
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// // `;

// // const CountBadge = styled.span`
// //   padding: 6px 12px;
// //   border-radius: 999px;
// //   background: #e0ecff;
// //   color: #1d4ed8;
// //   font-size: 0.85rem;
// // `;

// // const SearchInput = styled.input`
// //   width: 100%;
// //   padding: 12px 16px;
// //   border-radius: 12px;
// //   border: 1px solid #cbd5e1;
// //   background: #f8fafc;
// //   font-size: 0.95rem;
// //   margin-bottom: 20px;
// //   transition: all 0.2s ease;

// //   &:focus {
// //     outline: none;
// //     border-color: #3b82f6;
// //     background: #fff;
// //     box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
// //   }
// // `;

// // const UserList = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: 12px;
// //   overflow-y: auto;
// //   max-height: 600px;
// //   padding-right: 4px;

// //   &::-webkit-scrollbar { width: 6px; }
// //   &::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
// // `;

// // const UserCard = styled.div`
// //   padding: 16px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 16px;
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   background: #fff;
// //   transition: box-shadow 0.2s ease;

// //   &:hover {
// //     box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
// //   }
// // `;

// // const UserInfo = styled.div`
// //   h3 { margin: 0 0 4px; font-size: 1.05rem; color: #0f172a; }
// //   p { margin: 0; font-size: 0.85rem; color: #64748b; }
// // `;

// // const ActionButton = styled.button`
// //   padding: 8px 16px;
// //   border-radius: 12px;
// //   border: none;
// //   font-weight: 700;
// //   font-size: 0.9rem;
// //   cursor: pointer;
// //   transition: all 0.2s ease;
// //   white-space: nowrap;

// //   background: ${({ variant, isAssigned }) => 
// //     isAssigned ? '#f1f5f9' : variant === 'add' ? '#eff6ff' : '#fef2f2'};
// //   color: ${({ variant, isAssigned }) => 
// //     isAssigned ? '#94a3b8' : variant === 'add' ? '#1d4ed8' : '#dc2626'};

// //   &:hover:not(:disabled) {
// //     background: ${({ variant }) => variant === 'add' ? '#dbeafe' : '#fee2e2'};
// //   }
  
// //   &:disabled {
// //     cursor: not-allowed;
// //   }
// // `;

// // const EmptyState = styled.div`
// //   text-align: center;
// //   padding: 40px 20px;
// //   color: #64748b;
// //   font-size: 0.95rem;
// //   background: #f8fafc;
// //   border-radius: 12px;
// //   border: 1px dashed #e2e8f0;
// //   margin-top: auto;
// //   margin-bottom: auto;
// // `;

// // const Message = styled.div`
// //   background-color: ${({ type }) => (type === "error" ? "#fee2e2" : "#dcfce7")};
// //   color: ${({ type }) => (type === "error" ? "#dc2626" : "#16a34a")};
// //   padding: 14px 20px;
// //   border-radius: 12px;
// //   border: 1px solid ${({ type }) => (type === "error" ? "#f87171" : "#86efac")};
// //   font-weight: 700;
// //   margin-bottom: 20px;
// //   text-align: center;
// // `;

// // const Spinner = styled.div`
// //   width: 40px;
// //   height: 40px;
// //   margin: 40px auto;
// //   border-radius: 50%;
// //   border: 4px solid #e0ecff;
// //   border-top-color: #1d4ed8;
// //   animation: spin 0.8s linear infinite;

// //   @keyframes spin {
// //     to { transform: rotate(360deg); }
// //   }
// // `;

// // /* ================= MAIN COMPONENT ================= */
// // const SuperAdminManageTeam = ({ user }) => {
// //   const navigate = useNavigate();
  
// //   const [allStaff, setAllStaff] = useState([]);
// //   const [myTeam, setMyTeam] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [actionLoading, setActionLoading] = useState(null); 
// //   const [searchTerm, setSearchTerm] = useState("");

// //   // Messaging state
// //   const [successMsg, setSuccessMsg] = useState("");
// //   const [errorMsg, setErrorMsg] = useState("");

// //   useEffect(() => {
// //     fetchData();
// //   }, []);

// //   // Auto-clear messages
// //   useEffect(() => {
// //     if (successMsg || errorMsg) {
// //       const timer = setTimeout(() => {
// //         setSuccessMsg("");
// //         setErrorMsg("");
// //       }, 4000);
// //       return () => clearTimeout(timer);
// //     }
// //   }, [successMsg, errorMsg]);

// //   const fetchData = async () => {
// //     try {
// //       setLoading(true);
// //       const [allStaffRes, myTeamRes] = await Promise.all([
// //         api.get('/auth/all-staff'),
// //         api.get('/auth/my-team')
// //       ]);

// //       const myTeamData = myTeamRes.data.data;
// //       const myTeamIds = myTeamData.map(staff => staff._id);

// //       // Filter out 'my team' from the 'all staff' list
// //       const otherStaffData = allStaffRes.data.data.filter(staff => !myTeamIds.includes(staff._id));

// //       setAllStaff(otherStaffData);
// //       setMyTeam(myTeamData);
// //     } catch (error) {
// //       setErrorMsg("Failed to fetch staff data. Please refresh the page.");
// //       console.error(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleAddStaff = async (staffId, staffName) => {
// //     setActionLoading(staffId);
// //     setErrorMsg("");
// //     setSuccessMsg("");
// //     try {
// //       await api.put(`/auth/assign-staff/${staffId}`);
// //       setSuccessMsg(`Successfully added ${staffName} to your team.`);
// //       fetchData(); // Refreshes both lists
// //     } catch (error) {
// //       setErrorMsg("Failed to add staff member. Please try again.");
// //     } finally {
// //       setActionLoading(null);
// //     }
// //   };

// //   const handleRemoveStaff = async (staffId, staffName) => {
// //     if (!window.confirm(`Are you sure you want to remove ${staffName} from your team?`)) return;
    
// //     setActionLoading(staffId);
// //     setErrorMsg("");
// //     setSuccessMsg("");
// //     try {
// //       await api.put(`/auth/remove-staff/${staffId}`);
// //       setSuccessMsg(`Removed ${staffName} from your team.`);
// //       fetchData();
// //     } catch (error) {
// //       setErrorMsg("Failed to remove staff member. Please try again.");
// //     } finally {
// //       setActionLoading(null);
// //     }
// //   };

// //   // Filter Directory by search term
// //   const filteredStaff = allStaff.filter(staff => 
// //     `${staff.firstName} ${staff.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
// //     (staff.unit || "").toLowerCase().includes(searchTerm.toLowerCase())
// //   );

// //   return (
// //     <AppContainer>
// //       <NavBarSuper user={user} />
      
// //       <PageWrapper>
// //         {/* Navigation Back Button */}
// //         <BackButton onClick={() => navigate('/supervisor/dashboard')}>
// //           ← Back to Dashboard
// //         </BackButton>

// //         <HeroCard>
// //           <div>
// //             <HeroTitle>Manage Your Team</HeroTitle>
// //             <HeroText>Browse the Department/Zone directory and add unassigned staff members to your timeline.</HeroText>
// //           </div>
// //         </HeroCard>

// //         {/* Status Messages */}
// //         {successMsg && <Message type="success">{successMsg}</Message>}
// //         {errorMsg && <Message type="error">{errorMsg}</Message>}

// //         <Grid>
// //           {/* COLUMN 1: Department/Zone DIRECTORY */}
// //           <ColumnCard>
// //             <Title>
// //               Department/Zone Directory
// //               <CountBadge>{filteredStaff.length}</CountBadge>
// //             </Title>
            
// //             <SearchInput 
// //               type="text" 
// //               placeholder="Search by name or unit..." 
// //               value={searchTerm}
// //               onChange={(e) => setSearchTerm(e.target.value)}
// //             />

// //             {loading ? <Spinner /> : filteredStaff.length === 0 ? (
// //               <EmptyState>No staff members found matching your search.</EmptyState>
// //             ) : (
// //               <UserList>
// //                 {filteredStaff.map(staff => {
// //                   const isAssigned = !!staff.supervisorId; 
// //                   const staffFullName = `${staff.firstName} ${staff.surname}`;

// //                   return (
// //                     <UserCard key={staff._id}>
// //                       <UserInfo>
// //                         <h3>{staffFullName}</h3>
// //                         <p>{staff.unit} | {staff.department || "No Dept"}</p>
// //                       </UserInfo>
                      
// //                       <ActionButton 
// //                         variant="add" 
// //                         isAssigned={isAssigned}
// //                         onClick={() => handleAddStaff(staff._id, staffFullName)}
// //                         disabled={isAssigned || actionLoading === staff._id}
// //                       >
// //                         {actionLoading === staff._id 
// //                           ? "Adding..." 
// //                           : isAssigned 
// //                             ? "Assigned" 
// //                             : "+ Add to Team"}
// //                       </ActionButton>
// //                     </UserCard>
// //                   );
// //                 })}
// //               </UserList>
// //             )}
// //           </ColumnCard>

// //           {/* COLUMN 2: MY TEAM */}
// //           <ColumnCard>
// //             <Title>
// //               My Current Team
// //               <CountBadge>{myTeam.length}</CountBadge>
// //             </Title>
            
// //             {loading ? <Spinner /> : myTeam.length === 0 ? (
// //               <EmptyState>You have not added any staff to your team yet.</EmptyState>
// //             ) : (
// //               <UserList>
// //                 {myTeam.map(staff => {
// //                   const staffFullName = `${staff.firstName} ${staff.surname}`;
// //                   return (
// //                     <UserCard key={staff._id}>
// //                       <UserInfo>
// //                         <h3>{staffFullName}</h3>
// //                         <p>{staff.unit} | {staff.department || "No Dept"}</p>
// //                       </UserInfo>
// //                       <ActionButton 
// //                         variant="remove" 
// //                         onClick={() => handleRemoveStaff(staff._id, staffFullName)}
// //                         disabled={actionLoading === staff._id}
// //                       >
// //                         {actionLoading === staff._id ? "Removing..." : "Remove"}
// //                       </ActionButton>
// //                     </UserCard>
// //                   );
// //                 })}
// //               </UserList>
// //             )}
// //           </ColumnCard>
// //         </Grid>
// //       </PageWrapper>
// //       <Footer />
// //     </AppContainer>
// //   );
// // };

// // export default SuperAdminManageTeam;

// // //Com




// // import React, { useState, useEffect } from 'react';
// // import styled from 'styled-components';
// // import { useNavigate } from 'react-router-dom';
// // import NavBarSuper from './NavBarSuper';
// // import Footer from './Footer';
// // import api from '../api'; 

// // /* ================= STYLED COMPONENTS ================= */
// // const AppContainer = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   min-height: 100vh;
// //   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// // `;

// // const PageWrapper = styled.div`
// //   flex: 1 0 auto;
// //   width: min(1200px, calc(100% - 32px));
// //   margin: 90px auto 30px;
// // `;
// // const HeroTitle = styled.h1`
// //   margin: 0 0 8px;
// //   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
// //   font-weight: 800;
// // `;
// // const HeroText = styled.p`
// //   margin: 0;
// //   color: rgba(255, 255, 255, 0.86);
// //   font-size: 0.98rem;
// // `;
// // const BackButton = styled.button`
// //   display: inline-flex;
// //   align-items: center;
// //   gap: 8px;
// //   background: none;
// //   border: none;
// //   color: #1d4ed8;
// //   font-weight: 800;
// //   font-size: 1.05rem;
// //   cursor: pointer;
// //   margin-bottom: 20px;
// //   padding: 0;
// //   transition: transform 0.2s ease;
// //   &:hover { transform: translateX(-4px); }
// // `;

// // const HeroCard = styled.div`
// //   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
// //   color: #fff;
// //   border-radius: 24px;
// //   padding: 28px;
// //   margin-bottom: 22px;
// //   box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
// // `;

// // const SelectorCard = styled.div`
// //   background: white;
// //   padding: 20px;
// //   border-radius: 18px;
// //   margin-bottom: 24px;
// //   border: 1px solid #e2e8f0;
// //   display: flex;
// //   align-items: center;
// //   gap: 20px;
// //   flex-wrap: wrap;
// // `;

// // const Select = styled.select`
// //   padding: 12px;
// //   border-radius: 12px;
// //   border: 2px solid #1d4ed8;
// //   font-weight: 700;
// //   flex: 1;
// //   min-width: 250px;
// //   outline: none;
// // `;

// // const Grid = styled.div`
// //   display: grid;
// //   grid-template-columns: 1fr 1fr;
// //   gap: 24px;
// //   @media (max-width: 900px) { grid-template-columns: 1fr; }
// // `;

// // const ColumnCard = styled.div`
// //   background: rgba(255, 255, 255, 0.96);
// //   border-radius: 22px;
// //   padding: 24px;
// //   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
// //   border: 1px solid rgba(148, 163, 184, 0.16);
// //   min-height: 500px;
// //   display: flex;
// //   flex-direction: column;
// // `;

// // const Title = styled.h2`
// //   color: #0f172a;
// //   font-size: 1.2rem;
// //   font-weight: 800;
// //   margin: 0 0 20px 0;
// //   display: flex;
// //   justify-content: space-between;
// // `;

// // const UserList = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: 12px;
// //   overflow-y: auto;
// //   max-height: 500px;
// // `;

// // const UserCard = styled.div`
// //   padding: 14px;
// //   border: 1px solid #e2e8f0;
// //   border-radius: 16px;
// //   display: flex;
// //   justify-content: space-between;
// //   align-items: center;
// //   background: #fff;
// // `;

// // const ActionButton = styled.button`
// //   padding: 8px 14px;
// //   border-radius: 10px;
// //   border: none;
// //   font-weight: 700;
// //   font-size: 0.85rem;
// //   cursor: pointer;
// //   background: ${({ variant }) => variant === 'add' ? '#eff6ff' : '#fef2f2'};
// //   color: ${({ variant }) => variant === 'add' ? '#1d4ed8' : '#dc2626'};
// //   &:disabled { opacity: 0.5; cursor: not-allowed; }
// // `;

// // const Message = styled.div`
// //   padding: 12px;
// //   border-radius: 10px;
// //   margin-bottom: 15px;
// //   font-weight: bold;
// //   text-align: center;
// //   background: #dcfce7;
// //   color: #16a34a;
// // `;

// // /* ================= MAIN COMPONENT ================= */
// // const SuperAdminManageTeam = ({ user }) => {
// //   const navigate = useNavigate();
  
// //   const [allStaff, setAllStaff] = useState([]);
// //   const [supervisors, setSupervisors] = useState([]);
// //   const [selectedSupId, setSelectedSupId] = useState("");
// //   const [loading, setLoading] = useState(true);
// //   const [successMsg, setSuccessMsg] = useState("");

// //   useEffect(() => {
// //     fetchInitialData();
// //   }, []);

// //   const fetchInitialData = async () => {
// //     try {
// //       setLoading(true);
// //       // We fetch all users, then filter locally for clarity
// //       const res = await api.get('/auth/all-staff'); 
// //       const users = res.data.data;
      
// //       setAllStaff(users.filter(u => u.role === 'staff'));
// //       setSupervisors(users.filter(u => u.role === 'supervisor' || u.role === 'admin'));
// //     } catch (error) {
// //       console.error("Fetch error", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleAddStaffToTeam = async (staffId, staffName) => {
// //     if (!selectedSupId) return alert("Please select a supervisor first.");
// //     try {
// //       await api.put(`/auth/assign-staff/${staffId}`, { supervisorId: selectedSupId });
// //       setSuccessMsg(`Assigned ${staffName} to team.`);
// //       fetchInitialData();
// //       setTimeout(() => setSuccessMsg(""), 3000);
// //     } catch (error) {
// //       alert("Failed to assign staff.");
// //     }
// //   };

// //   const handleRemoveStaffFromTeam = async (staffId, staffName) => {
// //     if (!selectedSupId) return;
// //     if (!window.confirm(`Remove ${staffName} from this team?`)) return;

// //     try {
// //       await api.put(`/auth/remove-staff-from-team/${staffId}`, { supervisorId: selectedSupId });
// //       setSuccessMsg(`Removed ${staffName} from team.`);
// //       fetchInitialData();
// //       setTimeout(() => setSuccessMsg(""), 3000);
// //     } catch (error) {
// //       alert("Failed to remove staff.");
// //     }
// //   };

// //   // Filter logic for current team view
// //   const currentTeam = allStaff.filter(s => s.supervisorId?.includes(selectedSupId));
// //   const availableDirectory = allStaff.filter(s => !s.supervisorId?.includes(selectedSupId));

// //   return (
// //     <AppContainer>
// //       <NavBarSuper user={user} />
// //       <PageWrapper>
// //         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back</BackButton>
        
// //         <HeroCard>
// //           <HeroTitle>Global Team Management</HeroTitle>
// //           <HeroText>Assign staff members to different supervisors across the organization.</HeroText>
// //         </HeroCard>

// //         {successMsg && <Message>{successMsg}</Message>}

// //         <SelectorCard>
// //           <div style={{ fontWeight: 800, color: '#0f172a' }}>Select Supervisor to Manage:</div>
// //           <Select value={selectedSupId} onChange={(e) => setSelectedSupId(e.target.value)}>
// //             <option value="">-- Choose a Supervisor --</option>
// //             {supervisors.map(sup => (
// //               <option key={sup._id} value={sup._id}>{sup.firstName} {sup.surname} ({sup.unit})</option>
// //             ))}
// //           </Select>
// //         </SelectorCard>

// //         {!selectedSupId ? (
// //           <div style={{textAlign: 'center', padding: '50px', color: '#64748b'}}>
// //             <h3>Please select a supervisor above to manage their team assignments.</h3>
// //           </div>
// //         ) : (
// //           <Grid>
// //             {/* COLUMN 1: DIRECTORY */}
// //             <ColumnCard>
// //               <Title>Directory <span>{availableDirectory.length} available</span></Title>
// //               <UserList>
// //                 {availableDirectory.map(staff => (
// //                   <UserCard key={staff._id}>
// //                     <div>
// //                       <div style={{ fontWeight: 700 }}>{staff.firstName} {staff.surname}</div>
// //                       <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{staff.unit}</div>
// //                     </div>
// //                     <ActionButton variant="add" onClick={() => handleAddStaffToTeam(staff._id, staff.firstName)}>
// //                       + Assign
// //                     </ActionButton>
// //                   </UserCard>
// //                 ))}
// //               </UserList>
// //             </ColumnCard>

// //             {/* COLUMN 2: SELECTED TEAM */}
// //             <ColumnCard>
// //               <Title>Assigned Team <span>{currentTeam.length} members</span></Title>
// //               <UserList>
// //                 {currentTeam.length === 0 ? <p>No staff members assigned to this supervisor.</p> : 
// //                   currentTeam.map(staff => (
// //                   <UserCard key={staff._id}>
// //                     <div>
// //                       <div style={{ fontWeight: 700 }}>{staff.firstName} {staff.surname}</div>
// //                       <div style={{ fontSize: '0.8rem', color: '#64748b' }}>{staff.unit}</div>
// //                     </div>
// //                     <ActionButton variant="remove" onClick={() => handleRemoveStaffFromTeam(staff._id, staff.firstName)}>
// //                       Remove
// //                     </ActionButton>
// //                   </UserCard>
// //                 ))}
// //               </UserList>
// //             </ColumnCard>
// //           </Grid>
// //         )}
// //       </PageWrapper>
// //       <Footer />
// //     </AppContainer>
// //   );
// // };

// // export default SuperAdminManageTeam;



// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api'; 
// //my-team
// /* ================= STYLED COMPONENTS ================= */
// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1300px, calc(100% - 32px));
//   margin: 90px auto 30px;
// `;

// const BackButton = styled.button`
//   display: inline-flex; align-items: center; gap: 8px; background: none;
//   border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
//   margin-bottom: 20px; transition: transform 0.2s ease;
//   &:hover { transform: translateX(-4px); }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff; border-radius: 24px; padding: 28px; margin-bottom: 22px;
// `;

// const SelectorCard = styled.div`
//   background: white; padding: 25px; border-radius: 20px;
//   margin-bottom: 24px; border: 1px solid #e2e8f0;
//   display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
//   box-shadow: 0 10px 25px rgba(0,0,0,0.05);
// `;

// const Select = styled.select`
//   padding: 14px; border-radius: 12px; border: 2px solid #1d4ed8;
//   font-weight: 700; flex: 1; min-width: 300px; outline: none;
// `;

// const Grid = styled.div`
//   display: grid; grid-template-columns: 1.2fr 1fr; gap: 24px;
//   @media (max-width: 1024px) { grid-template-columns: 1fr; }
// `;

// const ColumnCard = styled.div`
//   background: white; border-radius: 22px; padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08); border: 1px solid #e2e8f0;
//   min-height: 600px; display: flex; flex-direction: column;
// `;

// const Title = styled.h2`
//   color: #0f172a; font-size: 1.2rem; font-weight: 800; margin: 0 0 20px 0;
//   display: flex; justify-content: space-between; align-items: center;
// `;

// const RoleBadge = styled.span`
//   font-size: 10px; text-transform: uppercase; padding: 3px 8px; border-radius: 6px;
//   margin-left: 8px; font-weight: 900;
//   background: ${props => props.role === 'supervisor' ? '#fef3c7' : '#e0f2fe'};
//   color: ${props => props.role === 'supervisor' ? '#92400e' : '#0369a1'};
// `;

// const SearchInput = styled.input`
//   width: 100%; padding: 12px; border-radius: 10px; border: 1px solid #cbd5e1;
//   margin-bottom: 15px;
// `;

// const UserList = styled.div`
//   display: flex; flex-direction: column; gap: 10px; overflow-y: auto; max-height: 550px;
// `;

// const UserCard = styled.div`
//   padding: 14px; border: 1px solid #f1f5f9; border-radius: 14px;
//   display: flex; justify-content: space-between; align-items: center;
//   background: #fff; transition: all 0.2s;
//   &:hover { border-color: #cbd5e1; background: #f8fafc; }
// `;

// const ActionButton = styled.button`
//   padding: 8px 16px; border-radius: 10px; border: none; font-weight: 700;
//   cursor: pointer; font-size: 0.85rem;
//   background: ${props => props.variant === 'add' ? '#1d4ed8' : '#dc2626'};
//   color: white;
//   &:disabled { opacity: 0.3; cursor: not-allowed; }
// `;
// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   font-size: 0.98rem;
// `;
// /* ================= MAIN COMPONENT ================= */
// const SuperAdminManageTeam = ({ user }) => {
//   const navigate = useNavigate();
  
//   const [users, setUsers] = useState([]); // All users in the company
//   const [selectedSupId, setSelectedSupId] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [successMsg, setSuccessMsg] = useState("");

//   useEffect(() => {
//     fetchAllUsers();
//   }, []);

//   const fetchAllUsers = async () => {
//     try {
//       setLoading(true);
//       // NOTE: You should ensure your backend '/auth/all-staff' actually returns everyone 
//       // OR update the route to return all users for super_admin
//       const res = await api.get('/auth/all-staff'); 
//       setUsers(res.data.data);
//     } catch (error) {
//       console.error("Fetch error", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAssignment = async (targetUserId, userName) => {
//     if (!selectedSupId) return alert("Select a Supervisor first!");
//     try {
//       await api.put(`/auth/assign-staff/${targetUserId}`, { supervisorId: selectedSupId });
//       setSuccessMsg(`Linked ${userName} to the selected supervisor.`);
//       fetchAllUsers(); // Refresh global state
//       setTimeout(() => setSuccessMsg(""), 3000);
//     } catch (error) {
//       alert("Failed to assign user.");
//     }
//   };

//   const handleRemoval = async (targetUserId, userName) => {
//     if (!window.confirm(`Remove ${userName} from this supervisor's team?`)) return;
//     try {
//       await api.put(`/auth/remove-staff-from-team/${targetUserId}`, { supervisorId: selectedSupId });
//       setSuccessMsg(`Removed ${userName} from the team.`);
//       fetchAllUsers();
//       setTimeout(() => setSuccessMsg(""), 3000);
//     } catch (error) {
//       alert("Failed to remove user.");
//     }
//   };

//   // --- LOGIC ---
  
//   // 1. Get list of potential Bosses (Supervisors/Admins)
//   const potentialBosses = users.filter(u => ['supervisor', 'admin', 'super_admin'].includes(u.role));

//   // 2. Identify the currently selected team members
//   const currentTeam = users.filter(u => u.supervisorId?.includes(selectedSupId));

//   // 3. Identify everyone else (Directory)
//   // We exclude the selected supervisor themselves (can't report to yourself)
//   const directory = users.filter(u => 
//     u._id !== selectedSupId && 
//     !u.supervisorId?.includes(selectedSupId) &&
//     (
//         `${u.firstName} ${u.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         u.unit?.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//   );
// ///api/auth/my-team
//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />
//       <PageWrapper>
//         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back</BackButton>
        
//         <HeroCard>
//           <HeroTitle>Organizational Hierarchy Manager</HeroTitle>
//           <HeroText>Super Admin Control: Assign any Staff or Supervisor to report to a specific lead.</HeroText>
//         </HeroCard>

//         {successMsg && <div style={{background: '#dcfce7', color: '#16a34a', padding: '15px', borderRadius: '12px', marginBottom: '20px', fontWeight: 'bold', textAlign: 'center'}}>{successMsg}</div>}

//         <SelectorCard>
//           <div style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.1rem' }}>Manage Team for Supervisor:</div>
//           <Select value={selectedSupId} onChange={(e) => setSelectedSupId(e.target.value)}>
//             <option value="">-- Click to select a Supervisor --</option>
//             {potentialBosses.map(sup => (
//               <option key={sup._id} value={sup._id}>
//                 {sup.firstName} {sup.surname} — {sup.unit} ({sup.role})
//               </option>
//             ))}
//           </Select>
//         </SelectorCard>

//         {!selectedSupId ? (
//           <ColumnCard style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#64748b'}}>
//             <h2 style={{fontSize: '2rem'}}>⬆️</h2>
//             <p>Select a supervisor from the dropdown to begin managing their reporting line.</p>
//           </ColumnCard>
//         ) : (
//           <Grid>
//             {/* COLUMN 1: GLOBAL DIRECTORY */}
//             <ColumnCard>
//               <Title>
//                 Global Directory 
//                 <span style={{fontSize: '0.8rem', background: '#f1f5f9', padding: '4px 10px', borderRadius: '8px'}}>
//                   {directory.length} Users Available
//                 </span>
//               </Title>
//               <SearchInput 
//                 placeholder="Search by name, unit, or department..." 
//                 value={searchTerm} 
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <UserList>
//                 {directory.map(u => (
//                   <UserCard key={u._id}>
//                     <div>
//                       <div style={{fontWeight: 700}}>{u.firstName} {u.surname} <RoleBadge role={u.role}>{u.role}</RoleBadge></div>
//                       <div style={{fontSize: '0.8rem', color: '#64748b'}}>{u.unit} | {u.department}</div>
//                     </div>
//                     <ActionButton variant="add" onClick={() => handleAssignment(u._id, u.firstName)}>
//                       + Assign to Team
//                     </ActionButton>
//                   </UserCard>
//                 ))}
//               </UserList>
//             </ColumnCard>

//             {/* COLUMN 2: THE TEAM UNDER SELECTED SUPERVISOR */}
//             <ColumnCard>
//               <Title>
//                 Current Reporting Line
//                 <span style={{fontSize: '0.8rem', background: '#dcfce7', color: '#16a34a', padding: '4px 10px', borderRadius: '8px'}}>
//                   {currentTeam.length} Members
//                 </span>
//               </Title>
//               <UserList>
//                 {currentTeam.length === 0 ? (
//                   <div style={{textAlign: 'center', marginTop: '50px', color: '#94a3b8'}}>
//                     This supervisor currently has no team members assigned.
//                   </div>
//                 ) : (
//                   currentTeam.map(u => (
//                     <UserCard key={u._id} style={{borderColor: '#bbf7d0'}}>
//                       <div>
//                         <div style={{fontWeight: 700}}>{u.firstName} {u.surname} <RoleBadge role={u.role}>{u.role}</RoleBadge></div>
//                         <div style={{fontSize: '0.8rem', color: '#64748b'}}>{u.unit}</div>
//                       </div>
//                       <ActionButton variant="remove" onClick={() => handleRemoval(u._id, u.firstName)}>
//                         Remove
//                       </ActionButton>
//                     </UserCard>
//                   ))
//                 )}
//               </UserList>
//             </ColumnCard>
//           </Grid>
//         )}
//       </PageWrapper>
//       <Footer />
//     </AppContainer>
//   );
// };

// export default SuperAdminManageTeam;




// import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import NavBarSuper from './NavBarSuper';
// import Footer from './Footer';
// import api from '../api'; 

// /* ================= STYLED COMPONENTS ================= */
// const AppContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   min-height: 100vh;
//   background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
// `;

// const PageWrapper = styled.div`
//   flex: 1 0 auto;
//   width: min(1300px, calc(100% - 32px));
//   margin: 90px auto 30px;
// `;

// const BackButton = styled.button`
//   display: inline-flex; align-items: center; gap: 8px; background: none;
//   border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
//   margin-bottom: 20px; transition: transform 0.2s ease;
//   &:hover { transform: translateX(-4px); }
// `;

// const HeroCard = styled.div`
//   background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
//   color: #fff; border-radius: 24px; padding: 28px; margin-bottom: 22px;
// `;

// const HeroTitle = styled.h1`
//   margin: 0 0 8px;
//   font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
//   font-weight: 800;
// `;

// const HeroText = styled.p`
//   margin: 0;
//   color: rgba(255, 255, 255, 0.86);
//   font-size: 0.98rem;
// `;

// const SelectorCard = styled.div`
//   background: white; padding: 25px; border-radius: 20px;
//   margin-bottom: 24px; border: 1px solid #e2e8f0;
//   display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
//   box-shadow: 0 10px 25px rgba(0,0,0,0.05);
// `;

// const Select = styled.select`
//   padding: 14px; border-radius: 12px; border: 2px solid #1d4ed8;
//   font-weight: 700; flex: 1; min-width: 300px; outline: none;
// `;

// const Grid = styled.div`
//   display: grid; grid-template-columns: 1.2fr 1fr; gap: 24px;
//   @media (max-width: 1024px) { grid-template-columns: 1fr; }
// `;

// const ColumnCard = styled.div`
//   background: white; border-radius: 22px; padding: 24px;
//   box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08); border: 1px solid #e2e8f0;
//   min-height: 600px; display: flex; flex-direction: column;
// `;

// const Title = styled.h2`
//   color: #0f172a; font-size: 1.2rem; font-weight: 800; margin: 0 0 20px 0;
//   display: flex; justify-content: space-between; align-items: center;
// `;

// // 🔥 UPDATED: Role Badge to handle arrays natively
// const RoleBadge = styled.span`
//   font-size: 10px; text-transform: uppercase; padding: 3px 8px; border-radius: 6px;
//   margin-left: 8px; font-weight: 900;
//   background: ${props => props.$isManagement ? '#fef3c7' : '#e0f2fe'};
//   color: ${props => props.$isManagement ? '#92400e' : '#0369a1'};
// `;

// const SearchInput = styled.input`
//   width: 100%; padding: 12px; border-radius: 10px; border: 1px solid #cbd5e1;
//   margin-bottom: 15px;
// `;

// const UserList = styled.div`
//   display: flex; flex-direction: column; gap: 10px; overflow-y: auto; max-height: 550px;
// `;

// const UserCard = styled.div`
//   padding: 14px; border: 1px solid #f1f5f9; border-radius: 14px;
//   display: flex; justify-content: space-between; align-items: center;
//   background: #fff; transition: all 0.2s;
//   &:hover { border-color: #cbd5e1; background: #f8fafc; }
// `;

// const ActionButton = styled.button`
//   padding: 8px 16px; border-radius: 10px; border: none; font-weight: 700;
//   cursor: pointer; font-size: 0.85rem;
//   background: ${props => props.variant === 'add' ? '#1d4ed8' : '#dc2626'};
//   color: white;
//   &:disabled { opacity: 0.3; cursor: not-allowed; }
// `;

// /* ================= MAIN COMPONENT ================= */
// const SuperAdminManageTeam = ({ user }) => {
//   const navigate = useNavigate();
  
//   const [users, setUsers] = useState([]);
//   const [selectedSupId, setSelectedSupId] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [successMsg, setSuccessMsg] = useState("");

//   useEffect(() => {
//     fetchAllUsers();
//   }, []);

//   const fetchAllUsers = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get('/auth/all-staff'); 
//       setUsers(res.data.data);
//     } catch (error) {
//       console.error("Fetch error", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAssignment = async (targetUserId, userName) => {
//     if (!selectedSupId) return alert("Select a Supervisor first!");
//     try {
//       await api.put(`/auth/assign-staff/${targetUserId}`, { supervisorId: selectedSupId });
//       setSuccessMsg(`Linked ${userName} to the selected supervisor.`);
//       fetchAllUsers(); 
//       setTimeout(() => setSuccessMsg(""), 3000);
//     } catch (error) {
//       alert("Failed to assign user.");
//     }
//   };

//   const handleRemoval = async (targetUserId, userName) => {
//     if (!window.confirm(`Remove ${userName} from this supervisor's team?`)) return;
//     try {
//       await api.put(`/auth/remove-staff-from-team/${targetUserId}`, { supervisorId: selectedSupId });
//       setSuccessMsg(`Removed ${userName} from the team.`);
//       fetchAllUsers();
//       setTimeout(() => setSuccessMsg(""), 3000);
//     } catch (error) {
//       alert("Failed to remove user.");
//     }
//   };

//   // --- LOGIC ---
  
//   // 🔥 BUG FIX 1: Use .some() to check if the new `roles` array contains a management role
//   const potentialBosses = users.filter(u => {
//     const rolesArray = Array.isArray(u.roles) ? u.roles : [u.role];
//     return rolesArray.some(role => ['supervisor', 'admin', 'super_admin'].includes(role));
//   });

//   // 2. Identify the currently selected team members
//   const currentTeam = users.filter(u => u.supervisorId?.includes(selectedSupId));

//   // 3. Identify everyone else (Directory)
//   const directory = users.filter(u => 
//     u._id !== selectedSupId && 
//     !u.supervisorId?.includes(selectedSupId) &&
//     (
//         `${u.firstName} ${u.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         u.unit?.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//   );

//   // Helper to format the roles for display
//   const getPrimaryRole = (userObj) => {
//     const roles = Array.isArray(userObj.roles) ? userObj.roles : [userObj.role];
//     if (roles.includes('super_admin')) return 'Super Admin';
//     if (roles.includes('admin')) return 'Admin';
//     if (roles.includes('supervisor')) return 'Supervisor';
//     return 'Staff';
//   };

//   const isManagement = (userObj) => {
//     const roles = Array.isArray(userObj.roles) ? userObj.roles : [userObj.role];
//     return roles.some(r => ['supervisor', 'admin', 'super_admin'].includes(r));
//   };

//   return (
//     <AppContainer>
//       <NavBarSuper user={user} />
//       <PageWrapper>
//         <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back</BackButton>
        
//         <HeroCard>
//           <HeroTitle>Organizational Hierarchy Manager</HeroTitle>
//           <HeroText>Super Admin Control: Assign any Staff or Supervisor to report to a specific lead.</HeroText>
//         </HeroCard>

//         {successMsg && <div style={{background: '#dcfce7', color: '#16a34a', padding: '15px', borderRadius: '12px', marginBottom: '20px', fontWeight: 'bold', textAlign: 'center'}}>{successMsg}</div>}

//         <SelectorCard>
//           <div style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.1rem' }}>Manage Team for Supervisor:</div>
//           <Select value={selectedSupId} onChange={(e) => setSelectedSupId(e.target.value)}>
//             <option value="">-- Click to select a Supervisor --</option>
//             {potentialBosses.map(sup => (
//               <option key={sup._id} value={sup._id}>
//                 {sup.firstName} {sup.surname} — {sup.unit} ({getPrimaryRole(sup)})
//               </option>
//             ))}
//           </Select>
//         </SelectorCard>

//         {!selectedSupId ? (
//           <ColumnCard style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#64748b'}}>
//             <h2 style={{fontSize: '2rem'}}>⬆️</h2>
//             <p>Select a supervisor from the dropdown to begin managing their reporting line.</p>
//           </ColumnCard>
//         ) : (
//           <Grid>
//             {/* COLUMN 1: GLOBAL DIRECTORY */}
//             <ColumnCard>
//               <Title>
//                 Global Directory 
//                 <span style={{fontSize: '0.8rem', background: '#f1f5f9', padding: '4px 10px', borderRadius: '8px'}}>
//                   {directory.length} Users Available
//                 </span>
//               </Title>
//               <SearchInput 
//                 placeholder="Search by name, unit, or department..." 
//                 value={searchTerm} 
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               <UserList>
//                 {directory.map(u => (
//                   <UserCard key={u._id}>
//                     <div>
//                       {/* 🔥 BUG FIX 2: Updated role display */}
//                       <div style={{fontWeight: 700}}>
//                         {u.firstName} {u.surname} 
//                         <RoleBadge $isManagement={isManagement(u)}>{getPrimaryRole(u)}</RoleBadge>
//                       </div>
//                       <div style={{fontSize: '0.8rem', color: '#64748b'}}>{u.unit} | {u.department}</div>
//                     </div>
//                     <ActionButton variant="add" onClick={() => handleAssignment(u._id, u.firstName)}>
//                       + Assign to Team
//                     </ActionButton>
//                   </UserCard>
//                 ))}
//               </UserList>
//             </ColumnCard>

//             {/* COLUMN 2: THE TEAM UNDER SELECTED SUPERVISOR */}
//             <ColumnCard>
//               <Title>
//                 Current Reporting Line
//                 <span style={{fontSize: '0.8rem', background: '#dcfce7', color: '#16a34a', padding: '4px 10px', borderRadius: '8px'}}>
//                   {currentTeam.length} Members
//                 </span>
//               </Title>
//               <UserList>
//                 {currentTeam.length === 0 ? (
//                   <div style={{textAlign: 'center', marginTop: '50px', color: '#94a3b8'}}>
//                     This supervisor currently has no team members assigned.
//                   </div>
//                 ) : (
//                   currentTeam.map(u => (
//                     <UserCard key={u._id} style={{borderColor: '#bbf7d0'}}>
//                       <div>
//                         {/* 🔥 BUG FIX 3: Updated role display */}
//                         <div style={{fontWeight: 700}}>
//                           {u.firstName} {u.surname} 
//                           <RoleBadge $isManagement={isManagement(u)}>{getPrimaryRole(u)}</RoleBadge>
//                         </div>
//                         <div style={{fontSize: '0.8rem', color: '#64748b'}}>{u.unit}</div>
//                       </div>
//                       <ActionButton variant="remove" onClick={() => handleRemoval(u._id, u.firstName)}>
//                         Remove
//                       </ActionButton>
//                     </UserCard>
//                   ))
//                 )}
//               </UserList>
//             </ColumnCard>
//           </Grid>
//         )}
//       </PageWrapper>
//       <Footer />
//     </AppContainer>
//   );
// };

// export default SuperAdminManageTeam;



import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaExclamationCircle, FaSpinner } from 'react-icons/fa';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api'; 

/* ================= STYLED COMPONENTS ================= */
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
`;

const PageWrapper = styled.div`
  flex: 1 0 auto;
  width: min(1300px, calc(100% - 32px));
  margin: 90px auto 30px;
`;

const BackButton = styled.button`
  display: inline-flex; align-items: center; gap: 8px; background: none;
  border: none; color: #1d4ed8; font-weight: 800; cursor: pointer;
  margin-bottom: 20px; transition: transform 0.2s ease;
  &:hover { transform: translateX(-4px); }
`;

const HeroCard = styled.div`
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
  color: #fff; border-radius: 24px; padding: 28px; margin-bottom: 22px;
  position: relative;
  overflow: hidden;
`;

const HeroTitle = styled.h1`
  margin: 0 0 8px;
  font-size: clamp(1.4rem, 1.1rem + 1.2vw, 2.2rem);
  font-weight: 800;
  position: relative;
  z-index: 2;
`;

const HeroText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.98rem;
  position: relative;
  z-index: 2;
`;

// 🔥 NEW: Custom Toast Alert
const AlertToast = styled.div`
  background: ${props => props.$type === 'error' ? '#fef2f2' : '#f0fdf4'};
  border: 1px solid ${props => props.$type === 'error' ? '#fecaca' : '#bbf7d0'};
  color: ${props => props.$type === 'error' ? '#991b1b' : '#166534'};
  padding: 16px 20px;
  border-radius: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  animation: slideIn 0.3s ease;

  @keyframes slideIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const SelectorCard = styled.div`
  background: white; padding: 25px; border-radius: 20px;
  margin-bottom: 24px; border: 1px solid #e2e8f0;
  display: flex; align-items: center; gap: 20px; flex-wrap: wrap;
  box-shadow: 0 10px 25px rgba(0,0,0,0.05);
`;

const Select = styled.select`
  padding: 14px; border-radius: 12px; border: 2px solid #1d4ed8;
  font-weight: 700; flex: 1; min-width: 300px; outline: none;
  background: #f8fafc; cursor: pointer; transition: all 0.2s;
  &:focus { background: white; box-shadow: 0 0 0 4px rgba(29, 78, 216, 0.1); }
`;

const Grid = styled.div`
  display: grid; grid-template-columns: 1.2fr 1fr; gap: 24px;
  @media (max-width: 1024px) { grid-template-columns: 1fr; }
`;

const ColumnCard = styled.div`
  background: white; border-radius: 22px; padding: 24px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08); border: 1px solid #e2e8f0;
  min-height: 600px; display: flex; flex-direction: column;
`;

const Title = styled.h2`
  color: #0f172a; font-size: 1.2rem; font-weight: 800; margin: 0 0 20px 0;
  display: flex; justify-content: space-between; align-items: center;
`;

const RoleBadge = styled.span`
  font-size: 10px; text-transform: uppercase; padding: 4px 8px; border-radius: 6px;
  margin-left: 8px; font-weight: 900; letter-spacing: 0.05em;
  background: ${props => props.$isManagement ? '#fef3c7' : '#e0f2fe'};
  color: ${props => props.$isManagement ? '#92400e' : '#0369a1'};
`;

const SearchInput = styled.input`
  width: 100%; padding: 14px 16px; border-radius: 12px; border: 1px solid #cbd5e1;
  margin-bottom: 16px; background: #f8fafc; transition: all 0.2s;
  &:focus { background: white; border-color: #3b82f6; outline: none; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); }
`;

const UserList = styled.div`
  display: flex; flex-direction: column; gap: 10px; overflow-y: auto; max-height: 550px;
  padding-right: 4px;
  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
`;

const UserCard = styled.div`
  padding: 16px; border: 1px solid #f1f5f9; border-radius: 16px;
  display: flex; justify-content: space-between; align-items: center;
  background: #fff; transition: all 0.2s;
  &:hover { border-color: #cbd5e1; background: #f8fafc; transform: translateY(-1px); }
`;

const ActionButton = styled.button`
  padding: 10px 16px; border-radius: 10px; border: none; font-weight: 800;
  cursor: pointer; font-size: 0.85rem; display: flex; align-items: center; gap: 6px;
  background: ${props => props.variant === 'add' ? '#eff6ff' : '#fef2f2'};
  color: ${props => props.variant === 'add' ? '#1d4ed8' : '#dc2626'};
  transition: all 0.2s;
  &:hover:not(:disabled) { 
    background: ${props => props.variant === 'add' ? '#dbeafe' : '#fee2e2'}; 
  }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

/* 🔥 NEW: Custom Modal for Confirmations */
const ModalOverlay = styled.div`
  position: fixed; top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px);
  display: flex; justify-content: center; align-items: center; z-index: 1000;
`;

const ModalContent = styled.div`
  background: white; padding: 32px; border-radius: 24px; width: min(400px, 90%);
  text-align: center; box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  h3 { margin: 0 0 12px; font-weight: 800; color: #0f172a; }
  p { color: #64748b; margin: 0 0 24px; line-height: 1.5; }
`;

const ModalActions = styled.div`
  display: flex; gap: 12px;
  button {
    flex: 1; padding: 12px; border-radius: 12px; border: none; font-weight: 800; cursor: pointer;
    transition: all 0.2s;
  }
  .cancel { background: #f1f5f9; color: #475569; &:hover { background: #e2e8f0; } }
  .confirm { background: #dc2626; color: white; &:hover { background: #b91c1c; } }
`;


const ManageTeamButton = styled.button`
  background: #fff;
  color: #1d4ed8;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #f8fafc;
    transform: translateY(-2px);
  }
`;

/* ================= MAIN COMPONENT ================= */
const SuperAdminManageTeam = ({ user }) => {
  const navigate = useNavigate();
  
  const [users, setUsers] = useState([]);
  const [selectedSupId, setSelectedSupId] = useState("");
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null); // Track which user is being processed
  const [searchTerm, setSearchTerm] = useState("");
  
  // Alert States
  const [alert, setAlert] = useState({ show: false, message: "", type: "success" });
  const [confirmModal, setConfirmModal] = useState({ show: false, userId: null, userName: "" });

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const triggerAlert = (message, type = "success") => {
    setAlert({ show: true, message, type });
    setTimeout(() => setAlert({ show: false, message: "", type: "" }), 4000);
  };

  const fetchAllUsers = async () => {
    try {
      setLoading(true);
      const res = await api.get('/auth/all-staff'); 
      setUsers(res.data.data);
    } catch (error) {
      triggerAlert("Failed to fetch users. Please refresh the page.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleAssignment = async (targetUserId, userName) => {
    if (!selectedSupId) {
      triggerAlert("Please select a Supervisor from the dropdown first.", "error");
      return;
    }
    
    setActionLoading(targetUserId);
    try {
      await api.put(`/auth/assign-staff/${targetUserId}`, { supervisorId: selectedSupId });
      triggerAlert(`Successfully assigned ${userName} to the team.`);
      await fetchAllUsers(); 
    } catch (error) {
      triggerAlert(`Failed to assign ${userName}.`, "error");
    } finally {
      setActionLoading(null);
    }
  };

  const executeRemoval = async () => {
    const { userId, userName } = confirmModal;
    setConfirmModal({ show: false, userId: null, userName: "" });
    setActionLoading(userId);

    try {
      await api.put(`/auth/remove-staff-from-team/${userId}`, { supervisorId: selectedSupId });
      triggerAlert(`Removed ${userName} from the team.`);
      await fetchAllUsers();
    } catch (error) {
      triggerAlert(`Failed to remove ${userName}.`, "error");
    } finally {
      setActionLoading(null);
    }
  };

  // --- LOGIC ---
  const potentialBosses = users.filter(u => {
    const rolesArray = Array.isArray(u.roles) ? u.roles : [u.role];
    return rolesArray.some(role => ['supervisor', 'admin', 'super_admin'].includes(role));
  });

  const currentTeam = users.filter(u => u.supervisorId?.includes(selectedSupId));

  const directory = users.filter(u => 
    u._id !== selectedSupId && 
    !u.supervisorId?.includes(selectedSupId) &&
    (
        `${u.firstName} ${u.surname}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
        u.unit?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const getPrimaryRole = (userObj) => {
    const roles = Array.isArray(userObj.roles) ? userObj.roles : [userObj.role];
    if (roles.includes('super_admin')) return 'Super Admin';
    if (roles.includes('admin')) return 'Admin';
    if (roles.includes('supervisor')) return 'Supervisor';
    return 'Staff';
  };

  const isManagement = (userObj) => {
    const roles = Array.isArray(userObj.roles) ? userObj.roles : [userObj.role];
    return roles.some(r => ['supervisor', 'admin', 'super_admin'].includes(r));
  };
///super-admin/complianceSettings
  return (
    <AppContainer>
      <NavBarSuper user={user} />
      <PageWrapper>
        <BackButton onClick={() => navigate('/super-admin/dashboard')}>← Back to Dashboard</BackButton>
        
        <HeroCard>
          <HeroTitle>Organizational Hierarchy Manager</HeroTitle>
          <HeroText>Super Admin Control: Assign any Staff or Supervisor to report to a specific lead.</HeroText>
        </HeroCard>
          <ManageTeamButton onClick={() => navigate('/super-admin/complianceSettings')}>
            Set Compliance Date
          </ManageTeamButton>
        {/* CUSTOM ALERT TOAST */}
        {alert.show && (
          <AlertToast $type={alert.type}>
            {alert.type === 'error' ? <FaExclamationCircle size={20} /> : <FaCheckCircle size={20} />}
            {alert.message}
          </AlertToast>
        )}

        <SelectorCard>
          <div style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.1rem' }}>Manage Team for Supervisor:</div>
          <Select value={selectedSupId} onChange={(e) => setSelectedSupId(e.target.value)}>
            <option value="">-- Click to select a Supervisor --</option>
            {potentialBosses.map(sup => (
              <option key={sup._id} value={sup._id}>
                {sup.firstName} {sup.surname} — {sup.unit} ({getPrimaryRole(sup)})
              </option>
            ))}
          </Select>
        </SelectorCard>

        {!selectedSupId ? (
          <ColumnCard style={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: '#64748b'}}>
            <div style={{fontSize: '3rem', marginBottom: '10px', color: '#cbd5e1'}}>👥</div>
            <h2 style={{color: '#0f172a'}}>No Supervisor Selected</h2>
            <p style={{maxWidth: '400px'}}>Select a supervisor from the dropdown menu above to begin managing their direct reports.</p>
          </ColumnCard>
        ) : (
          <Grid>
            {/* COLUMN 1: GLOBAL DIRECTORY */}
            <ColumnCard>
              <Title>
                Global Directory 
                <span style={{fontSize: '0.8rem', background: '#f1f5f9', color: '#475569', padding: '6px 12px', borderRadius: '99px'}}>
                  {directory.length} Available
                </span>
              </Title>
              <SearchInput 
                placeholder="Search by name, unit, or department..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <UserList>
                {directory.map(u => (
                  <UserCard key={u._id}>
                    <div>
                      <div style={{fontWeight: 800, color: '#0f172a'}}>
                        {u.firstName} {u.surname} 
                        <RoleBadge $isManagement={isManagement(u)}>{getPrimaryRole(u)}</RoleBadge>
                      </div>
                      <div style={{fontSize: '0.85rem', color: '#64748b', marginTop: '4px'}}>{u.unit} | {u.department}</div>
                    </div>
                    <ActionButton 
                      variant="add" 
                      onClick={() => handleAssignment(u._id, u.firstName)}
                      disabled={actionLoading === u._id}
                    >
                      {actionLoading === u._id ? <FaSpinner className="fa-spin" /> : "+ Assign"}
                    </ActionButton>
                  </UserCard>
                ))}
              </UserList>
            </ColumnCard>

            {/* COLUMN 2: THE TEAM UNDER SELECTED SUPERVISOR */}
            <ColumnCard>
              <Title>
                Current Reporting Line
                <span style={{fontSize: '0.8rem', background: '#dcfce7', color: '#166534', padding: '6px 12px', borderRadius: '99px'}}>
                  {currentTeam.length} Members
                </span>
              </Title>
              <UserList>
                {currentTeam.length === 0 ? (
                  <div style={{textAlign: 'center', marginTop: '60px', color: '#94a3b8', padding: '20px', border: '2px dashed #e2e8f0', borderRadius: '16px'}}>
                    This supervisor currently has no team members assigned.
                  </div>
                ) : (
                  currentTeam.map(u => (
                    <UserCard key={u._id} style={{borderLeft: '4px solid #22c55e'}}>
                      <div>
                        <div style={{fontWeight: 800, color: '#0f172a'}}>
                          {u.firstName} {u.surname} 
                          <RoleBadge $isManagement={isManagement(u)}>{getPrimaryRole(u)}</RoleBadge>
                        </div>
                        <div style={{fontSize: '0.85rem', color: '#64748b', marginTop: '4px'}}>{u.unit}</div>
                      </div>
                      <ActionButton 
                        variant="remove" 
                        onClick={() => setConfirmModal({ show: true, userId: u._id, userName: u.firstName })}
                        disabled={actionLoading === u._id}
                      >
                        {actionLoading === u._id ? <FaSpinner className="fa-spin" /> : "Remove"}
                      </ActionButton>
                    </UserCard>
                  ))
                )}
              </UserList>
            </ColumnCard>
          </Grid>
        )}
      </PageWrapper>

      {/* CONFIRMATION MODAL */}
      {confirmModal.show && (
        <ModalOverlay>
          <ModalContent>
            <div style={{fontSize: '3rem', color: '#dc2626', marginBottom: '10px'}}>⚠️</div>
            <h3>Remove Team Member?</h3>
            <p>Are you sure you want to remove <strong>{confirmModal.userName}</strong> from this supervisor's reporting line? They will be returned to the Global Directory.</p>
            <ModalActions>
              <button className="cancel" onClick={() => setConfirmModal({ show: false, userId: null, userName: "" })}>Cancel</button>
              <button className="confirm" onClick={executeRemoval}>Yes, Remove</button>
            </ModalActions>
          </ModalContent>
        </ModalOverlay>
      )}

      <Footer />
    </AppContainer>
  );
};

export default SuperAdminManageTeam;